<template>
  <section>
    <div>
      <b-field
        class="search-field"
        label="Rechercher : "
      >
        <b-input
          type="texte"
          v-model="filterEntry"
          @input="addFilter()"
          :disabled="isLoading"
        ></b-input>
      </b-field>

      <b-select
        v-model="perPage"
        style="padding-left: 20px;"
      >
        <option value="10">10 par page</option>
        <option value="20">20 par page</option>
        <option value="50">50 par page</option>
        <option value="100">100 par page</option>
      </b-select>
    </div>

    <b-table
      class="b-table"
      style='list-style-type: none;'
      :data="myData"
      :striped="true"
      :hoverable="true"
      :loading="isLoading"
      paginated
      :per-page="perPage"
      :current-page.sync="currentPage"
      pagination-simple
      :mobile-cards="false"
    >
      >

      <template
        slot-scope="props"
        slot="header"
      >
        <b-tooltip
          :active="!!props.column.meta"
          :label="props.column.meta"
        >
          {{ props.column.label }}
        </b-tooltip>
      </template>

      <template slot-scope="props">
        <b-table-column
          meta="Positoion au classement général"
          label="Position"
          field="position"
          :centered="true"
          :sortable="filterEntry == ''"
        >
          <span
            v-if="props.row.position == '1er'"
            class="first-place"
          ><i
              class="fa fa-trophy-alt"
              style="font-size: 30px; margin-left: -10px"
            ></i>
            {{props.row.position}}
          </span>
          <span
            v-else-if="props.row.position == '2ème'"
            class="second-place"
          ><i
              class="fa fa-trophy"
              style="font-size: 20px;"
            ></i>
            {{props.row.position}}
          </span>
          <span
            v-else-if="props.row.position == '3ème'"
            class="third-place"
          >
            <i class="fa fa-medal"></i>
            {{props.row.position}}
          </span>
          <span v-else>
            {{props.row.position}}
          </span>

        </b-table-column>

        <b-table-column
          meta="Nom et Prénom de l'utilisateur"
          field="user_name"
          label="Utilisateur"
          :centered="true"
          :sortable="filterEntry == ''"
        >
          <span
            v-if="props.row.position == '1er'"
            class="first-place"
          >
            {{props.row.user_name}}
          </span>
          <span
            v-else-if="props.row.position == '2ème'"
            class="second-place"
          >
            {{props.row.user_name}}
          </span>
          <span
            v-else-if="props.row.position == '3ème'"
            class="third-place"
          >
            {{props.row.user_name}}
          </span>
          <span v-else>
            {{props.row.user_name}}
          </span>
        </b-table-column>

        <b-table-column
          meta="Score obtenu"
          field="score"
          label="Score"
          :centered="true"
          :sortable="filterEntry == ''"
        >
          <span
            v-if="props.row.position == '1er'"
            class="first-place"
          >
            {{props.row.score}} points
          </span>
          <span
            v-else-if="props.row.position == '2ème'"
            class="second-place"
          >
            {{props.row.score}} points
          </span>
          <span
            v-else-if="props.row.position == '3ème'"
            class="third-place"
          >
            {{props.row.score}} points
          </span>
          <span v-else>
            {{props.row.score}} points
          </span>

        </b-table-column>
      </template>

      <template slot="empty">
        <section class="section">
          <div
            v-if="!isLoading"
            class="content has-text-grey has-text-:centered"
          >
            <p>Pas de Scores</p>
          </div>
        </section>
      </template>
    </b-table>
  </section>
</template>

<script>
import _ from "lodash";
export default {
  name: "GameScoresTable",
  props: ["scores"],
  data: () => {
    return {
      isEmpty: false,
      isLoading: true,
      myData: [],
      storedScores: [],
      filterEntry: "",
      currentPage: 1,
      perPage: 10
    };
  },
  watch: {
    scores: function(newVal, oldVal) {
      if (this.scores.length > 0) {
        // watch it
        var sorted = JSON.parse(JSON.stringify(this.scores)).sort(
          (a, b) => new Date(b.score) - new Date(a.score)
        );
        var position = 1;
        for (var i = 0; i < sorted.length; i++) {
          if (i > 0) {
            if (sorted[i].score == sorted[i - 1].score) {
              sorted[i].position = sorted[i - 1].position;
            } else {
              position++;
              sorted[i].position = `${position}ème`;
            }
          } else {
            sorted[i].position = "1er";
          }
        }

        this.myData = sorted;
        this.isLoading = false;
        this.storedScores = JSON.parse(JSON.stringify(this.myData));

        this.addFilter();
      } else {
        this.isLoading = false;
        this.myData = [];
        this.storedScores = [];
      }
    }
  },
  methods: {
    addFilter() {
      var results = this.storedScores;
      if (this.filterEntry != "") {
        results = this.filteredResults(this.filterEntry);
      }
      this.myData = results;
    },
    resetAllFilters() {
      this.filterEntry = "";
      this.addFilter();
    },
    filteredResults(string) {
      return this.storedScores.filter(e =>
        e.user_name.toLowerCase().includes(string.toLowerCase())
      );
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.saleRow {
  text-align: center;
}

.b-table {
  width: auto;
  padding-right: 20px;
}

.b-input-number {
  width: 50px;
  margin-left: 15px;
}

.modal-line {
  display: flex;
  justify-content: space-between;
}

.modal-input-field {
  width: 175px;
  padding-left: 0px;
}

.b-modal-input-number {
  width: 100px;
}

.b-modal-select-field {
  width: 200px;
}

.first-place {
  color: gold;
  font-weight: 700;
}
.second-place {
  color: silver;
  font-weight: 700;
}
.third-place {
  color: orange;
  font-weight: 700;
}
</style>